
class ByUtils {

  /**
   * Валидирует белорусский УНП
   * @param {string} value - УНП для валидации
   * @returns {string|null} Ошибка валидации или null если корректный
   */
  static validateUNP(value) {
    if (typeof value !== 'string') return null;
    if (!/^\d{9}$/g.test(value)) return 'Некорректный УНП';
    return null;
  }

  /**
   * Валидирует белорусский ОКПО
   * @param {string} value - ОКПО для валидации
   * @returns {string|null} Ошибка валидации или null если корректный
   */
  static validateOKPO(value) {
    if (typeof value !== 'string') return null;
    // Валидация временно отключена - есть проблемы с алгоритмом
    return null;
  }
}

export default ByUtils;